import type { Session } from '@generated/components/SessionsTable';

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col gap-0.5">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-[hsl(var(--brand-gray))]">{label}</p>
      <p className="text-sm text-foreground">{value}</p>
    </div>
  );
}

export default function SessionCard({ session, clockHours }: { session: Session; clockHours?: string }) {
  return (
    <div className="border border-border bg-card">
      <div className="h-1 w-full bg-[hsl(var(--brand-blue))]" aria-hidden="true" />
      <div className="flex flex-col gap-3 p-4">
        <h3 className="text-base font-bold leading-snug text-foreground">{session.name}</h3>

        <div className="flex flex-col gap-1 border-l-2 border-[hsl(var(--brand-red))] pl-3">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-[hsl(var(--brand-gray))]">Date &amp; Location</p>
          <p className="text-sm text-foreground">
            {session.allSessionDatesLocation || session.day1Date?.toLocaleDateString() || '—'}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <Field label="Hosting Site" value={session.hostingSite ?? '—'} />
          <Field label="Subject" value={session.subjectManagedForAces ?? '—'} />
          <Field label="Grade Band" value={session.gradeBandS ?? '—'} />
          <Field label="Day Count" value={session.creditHoursAsDayCount ?? '—'} />
          <Field label="Clock Hours" value={clockHours ?? '—'} />
        </div>
      </div>
    </div>
  );
}
